export default "__VITE_ASSET__BJnCXPPW__"